import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-gdpr-dialog',
  templateUrl: './gdpr-dialog.component.html',
  styleUrls: ['./gdpr-dialog.component.css']
})
export class GdprDialogComponent implements OnInit {
  title = 'Modulo informativo, consenso informato ed informativa GDPR 2016/679 per il protocollo di studio';
  subtitle = 'Analisi della responsività e della robustezza di un sistema di autovalutazione\n' +
    'multidimensionale per pazienti affetti da malattie infiammatorie croniche intestinali,\n' +
    'nell’ambito di un sistema di telemedicina (IBDeHealth).';

  accepted = true;

  constructor(public dialogRef: MatDialogRef<GdprDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string) {
  }

  ngOnInit(): void {
  }

}
